// extracted by mini-css-extract-plugin
export default {"container":"style_container__CpcBu","innerBox":"style_innerBox__KxF20"};